'use client'

import React, { useRef } from 'react'
import curtainCloseBtn from '@/assets/img/catalog/catalog-sort-curtainClose.svg'
import Image from 'next/image'
import VacancySort from './VacancySort'

interface Props {
    curtainOpen: boolean,
    setCurtainOpen: (state: boolean) => void,
    filtersList: any,
    vacancySpecialization: number[],
    vacancyRegion: number[],
    setVacancySpecialization: (state: number) => void,
    setVacancyRegion: (state: number) => void
    resetFilters: () => void
}

const VacancySortCurtain: React.FC<Props> = ({ curtainOpen, setCurtainOpen, filtersList, vacancySpecialization, vacancyRegion, setVacancySpecialization, setVacancyRegion, resetFilters }) => {

    const curtainRef = useRef(null)
    const toggleCurtain = () => {
        setCurtainOpen(!curtainOpen)
        if (!curtainOpen) {
            document.body.classList.add('no-scroll')
        } else {
            document.body.classList.remove('no-scroll')
        }
    }

    React.useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {

            if (curtainRef.current && !event.composedPath().includes(curtainRef.current) && curtainOpen) {
                setCurtainOpen(false)
                document.body.classList.remove('no-scroll')

            }
        }

        document.body.addEventListener('click', handleClickOutside)
        return () => document.body.removeEventListener('click', handleClickOutside)
    }, [])

    return (
        <>
            <div ref={curtainRef} className={`catalog__sort-curtain ${curtainOpen ? "catalog__sort-curtain_open" : ''}`}>
                <VacancySort
                    resetFilters={resetFilters}
                    vacancyRegion={vacancyRegion}
                    vacancySpecialization={vacancySpecialization}
                    setVacancyRegion={(state) => setVacancyRegion(state)}
                    setVacancySpecialization={(state) => setVacancySpecialization(state)}
                    inContainer={true}
                    filtersList={filtersList} />
                <div onClick={toggleCurtain} className="catalog__sort-close-curtain">
                    <Image src={curtainCloseBtn} width={20} height={20} alt='close-button' />
                </div>
            </div>
        </>
    )
}

export default VacancySortCurtain
